import { render, staticRenderFns } from "./sixProgressBar.vue?vue&type=template&id=8244163a&scoped=true&"
import script from "./sixProgressBar.vue?vue&type=script&lang=js&"
export * from "./sixProgressBar.vue?vue&type=script&lang=js&"
import style0 from "./sixProgressBar.vue?vue&type=style&index=0&id=8244163a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8244163a",
  null
  
)

export default component.exports